import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../environments/environment';
import { AuthService } from './auth-service';
import { RequestBase } from './request-base';
import { map, catchError } from 'rxjs/operators';
import { Task } from '../components/task/task.model';
import { StorageService } from './storage.service';

export interface OwnTasksResponse {
    tasks: Task[];
}

@Injectable()
export class OwnTasksService extends RequestBase {

    constructor(
        public http: HttpClient,
        public authService: AuthService,
        public storageService: StorageService
    ) {
        super(http);
    }

    fetchOwnTasks(fetchHistory: boolean) {

        const sessionId = this.authService.sessionId;
        const apiUrl = environment.baseApiUrl.toString();
        const url =  apiUrl + `session/${sessionId}/own_tasks.json`;

        const httpOptions = {
            params: {
                cs: this.authService.checksum,
                show_history: fetchHistory.toString(),
            }
        };

        return this.http.get(url, httpOptions)
            .pipe(map((res: OwnTasksResponse) => res))
            .pipe(catchError(this.handleError));
    }

    setOwnTasks(passedTasks: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            this.fetchOwnTasks(passedTasks)
                .pipe(map(res => res))
                .subscribe( async data => {
                    await this.storageService.set('cacheTs', Date.now());
                    if (!passedTasks) {
                       await this.storageService.set('upcomingTasks', data.tasks || []);
                    } else {
                       await this.storageService.set('passedTasks', data.tasks || []);
                    }
                    resolve({});
                }, error => {
                    console.error('Own tasks response error' + error);
                    reject();
                }
            );
        });
    }
}
